import { z } from 'zod';
export const weightSourceSchema = z.enum(['nl_extracted', 'manual', 'health_import']);
export const createWeightSchema = z
    .object({
    measuredAt: z.string().datetime({ offset: true }),
    weightKg: z.number().positive().max(700),
    note: z.string().trim().max(500).optional(),
    timezone: z.string().trim().min(1).max(100).optional(),
})
    .strict();
export const weightRangeQuerySchema = z
    .object({
    from: z.string().date().optional(),
    to: z.string().date().optional(),
    timezone: z.string().trim().min(1).max(100).optional(),
})
    .strict()
    .refine((value) => !value.from || !value.to || value.from <= value.to, {
    message: 'from must be before or equal to to',
    path: ['from'],
});
export const weightTrendPointSchema = z.object({
    id: z.string().uuid(),
    localDate: z.string().date(),
    measuredAt: z.string().datetime(),
    scaleKg: z.number().positive().max(700),
    trendKg: z.number().positive().max(700),
    source: weightSourceSchema,
});
export const weightResponseSchema = z.object({
    points: z.array(weightTrendPointSchema),
});
//# sourceMappingURL=weight.js.map